<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiSendOutline } from "@mdi/js";
export default {
  name: "MdiSendOutline",
  data() {
    return {
      svgPath: mdiSendOutline,
    };
  },
};
</script>
